import { render, staticRenderFns } from "./AvailabilityQueueIndex.vue?vue&type=template&id=8dde725a"
import script from "./AvailabilityQueueIndex.vue?vue&type=script&lang=ts"
export * from "./AvailabilityQueueIndex.vue?vue&type=script&lang=ts"
import style0 from "./AvailabilityQueueIndex.vue?vue&type=style&index=0&id=8dde725a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports